import { ChangeDetectorRef, Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { ButtonModule, ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { HeaderOptions, HeaderElmnts, HeaderModule } from '@usitsdasdesign/dds-ng/header';
import { ProfileModule, ProfileOptions } from '@usitsdasdesign/dds-ng/profile';
import { WidthState, Themes, ButtonKind, Size } from '@usitsdasdesign/dds-ng/shared';
import { DdsConfigService } from '@usitsdasdesign/dds-ng/shared/dds-config';
import { Subscription } from 'rxjs';
import { SettingsPanelService } from './settings-panel/settings-panel.service';
import { SearchModule } from '@usitsdasdesign/dds-ng/search';
import { ContextMenuModule } from '@usitsdasdesign/dds-ng/context-menu';
import { SettingsPanelComponent } from './settings-panel/settings-panel.component';
import { FooterModule, FooterOptions } from '@usitsdasdesign/dds-ng/footer';
import { AceModule } from 'ngx-ace-wrapper';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        RouterModule,
        RouterOutlet,
        HeaderModule,
        SearchModule,
        ButtonModule,
        ProfileModule,
        ContextMenuModule,
        SettingsPanelComponent,
        FooterModule,
        AceModule,
        DatePipe,
    ],
    providers: [DatePipe],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    headerOptions: HeaderOptions = {
        name: "ECHO API Simulation",
        width: WidthState.full,
        theme: Themes.green,
    };

    routes = [
        { path: "/", title: "Home" },
        { path: "/projects", title: "Projects" },
    ];

    responsivePriority: HeaderElmnts[] = [
        HeaderElmnts.logo,
        HeaderElmnts.projectName,
        HeaderElmnts.profile,
        HeaderElmnts.nav,
        HeaderElmnts.icons,
        HeaderElmnts.search,
    ];

    buttonNavOptions: ButtonOptions = {
        theme: Themes.dark,
        kind: ButtonKind.primaryLoud,
        size: Size.lg,
    };

    buttonOptions: ButtonOptions = {
        theme: Themes.dark,
    };

    profileOptions: ProfileOptions = {
        username: "Keanu Reeves",
        nameLetter: "KR",
        userInfo: "Actor, musician",
        photoUrl: "assets/img/user.png",
    };

    footerOptions: FooterOptions = {
        customClass: '',
        ariaLabel: '',
        role: '',
        isInverse: true,
    };

    private subscriptions = new Subscription();

    get customLogoPath(): string {
        return this.headerOptions.isInverse ? 'assets/img/custom-logo_black.svg' : 'assets/img/custom-logo_white.svg';
    }

    get contentSeparatorColor(): string {
        let separatorColor: string;

        if (this.headerOptions.theme === 'custom') {
            separatorColor = this.headerOptions.isInverse ? '#6C768F' : '#22262F';
        } else {
            separatorColor = this.headerOptions.isInverse ? '#D0D0CE' : '#000';
        }

        return separatorColor;
    }

    get activeBtnNavState(): boolean {
        return this.headerOptions.theme === Themes.dark && !this.headerOptions.isInverse
    }

    constructor(
        private settingsPanelService: SettingsPanelService,
        private сonfigService: DdsConfigService,
        private cdr: ChangeDetectorRef
    ) {
        this.setHeaderTheme();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.settingsPanelService.isInverseHeader.subscribe((isInverse) => {
                this.headerOptions.isInverse = isInverse;
                this.buttonOptions.theme = Themes.dark;
                this.setHeaderTheme();
                this.cdr.detectChanges();
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private setHeaderTheme(): void {
        const theme = this.settingsPanelService.getItemToStorage("theme") || this.сonfigService.getConfig().theme;
        this.headerOptions.theme = theme;
    }
}
